import Jiva1 from '../../../Media/BSD/Tanakayu/Tanakayu Jiva.webp'
import Jiva2 from '../../../Media/BSD/Tanakayu/Tanakayu Jiva.webp'





const Jivaimages =[
Jiva1,Jiva2
]

export default Jivaimages;